import { render } from "./VideoInvestList.vue?vue&type=template&id=428df403&scoped=true"
import script from "./VideoInvestList.vue?vue&type=script&lang=js"
export * from "./VideoInvestList.vue?vue&type=script&lang=js"

import "./VideoInvestList.vue?vue&type=style&index=0&id=428df403&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428df403"]])

export default __exports__